module.exports = __webpack_public_path__ + "static/media/sn-1500c.d083a7c3.jpg";